import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumericspace, formatDate } from '../../commonClass/CommonValidation';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import Role from './Role';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const Department = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState();
    const [departmentdata, setDepartmentData] = useState([]);
    const [filteritems, setFilterItems] = useState([]);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const user = useSelector(store => store.userstatus.tba);
    const [form, setForm] = useState({
        DepartmentId: 0,
        DepartmentName: '',
        IsActive: false,
        UserId: 0,
        UserType: 0
    });

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = !form.IsActive
            setFormErrors({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            form.IsActive = !form?.IsActive
            setEditDisabled(true);
            setFormErrors({});
        }
        setModalShow(false);
    }

    //#region bind datatable
    const columns = [
        {
            name: 'Department Name',
            key: 'DepartmentName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (department) => department?.DepartmentName
        },

        {
            name: 'Status',
            key: 'Active',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (department) => department?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (department) => new Date(department?.CreatedOn),
            format: (department) => department?.CreatedDate
        },
        {
            name: 'Edit',
            selector: (list) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEditView(list, 'edit')}></i></button>
        },
        {
            name: 'View',
            selector: (list) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' onClick={() => handleEditView(list, 'view')}><i className="fa-regular fa-eye"></i></button>
        }
    ];

    //#endregion

    useEffect(() => {
        dispatch(loaderActions.start());
        getdepartmentlist();
    }, []);

    useEffect(() => {
        if (window.location.pathname !== '/dashboard') {
            let pagelink = user?.find(x => {
                if (x.PageLink === window.location.pathname)
                    return x.MenuId
            });
            let mid = user?.find(x => x.MenuId === pagelink.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
                setUserAdd(obj.URightAdd);
                setUserEdit(obj.URightEdit);
                setUserExport(obj.URightExport);

            });
        }
    }, [user])
    //#endregion

    const getdepartmentlist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/auth/v1/getalluserdepartment?UserType=' + form.UserType).then((departmentdata) => {
                departmentdata.data?.map((obj) => {
                    obj.Active = obj.IsActive ? 'Active' : 'InActive'
                    obj.CreatedDate = formatDate(obj?.CreatedOn)
                    return obj;
                })
                setDepartmentData(departmentdata.data);
                setFilterItems(departmentdata.data);
                dispatch(loaderActions.end());
            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const handleEditView = (data, type) => {
        setFormErrors({});
        setEditDisabled(false);
        setSerachDisable(true);
        setForm((form) => ({
            ...form,
            DepartmentId: data?.DepartmentId,
            DepartmentName: data?.DepartmentName,
            IsActive: data?.IsActive,
        }))
        setButtonAddEditText("Update");
        if (type === 'edit') {
            setDisabled(false);
        }
        else {
            setDisabled(true);
        }
    }

    const validateData = () => {
        let status = true;
        const error = {}
        if (form.DepartmentName?.trim()?.length === 0) {
            error.DepartmentName = "Kindly enter the department name";
            status = false;
        }
        if (Object.keys(error).length > 0) {
            let id = Object.keys(error)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }
        setFormErrors(error);
        return status;
    }

    const handleSubmitData = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user = GetLocalStorage();
                form.UserId = user?.userMasterID
                const DepartmentData = buttonaddeditText === 'Add' ? await postUsersData('/auth/v1/insertuserdepartment', form)
                    : await patchUsersData('/auth/v1/updateuserdepartment', form)
                const status = DepartmentData.status;
                if (!DepartmentData.status && !DepartmentData.data) {
                    dispatch({ type: 'ALERTING', message: DepartmentData.message });
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
                if (status) {
                    dispatch({ type: 'ALERTING', message: DepartmentData.message });
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: DepartmentData.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }

    const onChange = (e) => {
        var result;
        if ([e.target.name][0] === 'DepartmentName') {
            result = alphaNumericspace(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        setEditDisabled(true);
        setFormErrors('');
    }

    const handleClearClick = () => {
        setButtonAddEditText('Add');
        setDisabled(false);
        setFormErrors({});
        setForm((form) => ({
            ...form,
            DepartmentName: '',
            DepartmentId: 0,
            IsActive: false,
        }))
        getdepartmentlist();
        setEditDisabled(true);
        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');
    }

    //#endregion

    return (
        <>

            <div className="container-fluid mt-4 heading_color">
                <h3>Department & Role</h3>
            </div>
            <div className="container-fluid form_border pt-5 my-3">
                <div className='container mb-5 tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-lg-3 col-12 mx-auto" id="pills-tab" role="tablist">
                        <li className="nav-item mt-1 mx-1" role="presentation">
                            <button className="nav-link active" id="pills-Department-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Department" type="button" role="tab" aria-controls="pills-about"
                                aria-selected="true">Department</button>
                        </li>
                        <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button className="nav-link" id="pills-Role-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Role" type="button" role="tab" aria-controls="pills-tips"
                                aria-selected="false">Role</button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-Department" role="tabpanel"
                        aria-labelledby="pills-Department-tab">
                        <form action="" >
                            <div className="mb-1 row mx-1">
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Department Name</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input className="form-control"
                                                type="text"
                                                id='DepartmentName'
                                                name="DepartmentName"
                                                value={form.DepartmentName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Department Name'
                                                maxLength={35}
                                            />
                                            {formErrors.DepartmentName && <div className='text-danger text-start fs_14'>{formErrors.DepartmentName}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-6">
                                            <Switch
                                                onChange={handleisActive}
                                                checked={form?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-center">
                                {useradd === false && buttonaddeditText === "Add" ?
                                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={!useradd}>{buttonaddeditText}</button> :
                                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                                <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                            </div>
                            <CommonFilter
                                columns={columns}
                                filterList={filteritems}
                                searchDisabled={serchdisable}
                                getdata={getdepartmentlist}
                                setlistdata={setDepartmentData}
                                searchvalue={searchvalue}
                                setSearchValue={setSearchValue}
                                searchby={searchby}
                                setSerachBy={setSerachBy}
                            />

                            <CustomTable
                                columns={columns}
                                data={departmentdata}
                                PdfExport={false}
                                ExportToExcel={false}
                                disabled={!userexport}
                            />
                        </form>
                    </div>
                    <div className="tab-pane fade show" id="pills-Role" role="tabpanel"
                        aria-labelledby="pills-Role-tab">
                        <Role />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Department